<template>
    <div strat.comingsoon.v12019 class="max overflow-hidden">
        <div class="section banner white overflow-hidden hidden-xs-only">
            <div class="banner-bg grey lighten-5"></div>
            <div class="bg-rect amber-line"></div>
            <div class="bg-hollow black-line diag-rt"></div>
            <div class="liner-container">
                <div class="section liner l bgGrey mb-4"></div>
                <div class="section liner m bgGrey mb-4"></div>
                <div class="section liner s bgGrey mb-4"></div>
            </div>
            <div class="bg-circle-ls ol black-line"></div>
            <div class="bg-circle ol accent"></div>
            <div class="banner-title text-center">
                <div class="title-t dolo font-weight-regular">Strategery.</div>
                <div class="title-s roboto">Better Tools Create Better Results.</div>
            </div>
            <div class="bg-hollow tertiary-line mlb"></div>
            <v-sheet class="hotspot" color="transparent" @click="bypassCs()"></v-sheet>
            <div class="cs-copyright t12 grey--text text-uppercase">
                <v-layout justify-space-between px-12 align-center>
                    <div class="text-center">
                        <v-btn class="t10 mr-3" text color="grey" rounded @click="tc()">Terms & Conditions</v-btn>
                        <v-btn class="t10 mr-3" text color="grey" rounded @click="pp()">Privacy Policy</v-btn>
                    </div>
                    <div class="t10">© Copyright 2019. Dololabs LLC. All Rights Reserved.</div>
                </v-layout>
            </div>
        </div>
        <div class="mobi hidden-sm-and-up">
            <div class="section banner white overflow-hidden">
                <div class="banner-bg grey lighten-5"></div>
                <div class="bg-rect amber-line"></div>
                <div class="liner-container">
                    <div class="section liner l bgGrey mb-2"></div>
                    <div class="section liner m bgGrey mb-2"></div>
                    <div class="section liner s bgGrey mb-2"></div>
                </div>
                <div class="bg-circle-ls ol black-line"></div>
                <div class="bg-circle ol accent"></div>
                <div class="banner-title text-center">
                    <div class="title-t dolo font-weight-regular">Strategery.</div>
                    <div class="title-s roboto">Better Tools Create Better Results.</div>
                </div>
                <div class="bg-hollow tertiary-line mlb"></div>
                <v-sheet class="hotspot" color="transparent" @click="bypassCs()"></v-sheet>
                <div class="cs-copyright t12 grey--text text-uppercase">
                    <div class="text-center">
                        <v-btn class="t10 mr-3" text color="grey" rounded @click="tcMobi()">Terms & Conditions</v-btn>
                        <v-btn class="t10 mr-3" text color="grey" rounded @click="ppMobi()">Privacy Policy</v-btn>
                    </div>
                    <div class="t8 text-center">© Copyright 2019. Dololabs LLC. All Rights Reserved.</div>
                </div>
            </div>
            <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="mobiPp">
                <v-card class="pa-6">
                <privacy-policy @closePp="closePp()"/>
                </v-card>
            </v-dialog>
            <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="mobiTc">
                <v-card class="pa-6">
                    <terms @closeTc="closeTc()"/>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import privacyPolicy from '../views/privacy-policy'
    import terms from '../views/terms'

    export default {
        components: {
            privacyPolicy,
            terms
        },
        data: () => {
            return {
                mobiTc: false,
                mobiPp: false,
            }
        },
        methods: {
            bypassCs(){
                this.$emit('bypassCs')
            },
            pp(){
                this.$emit('pp')
            },
            tc(){
                this.$emit('tc')
            },
            tcMobi() {
                this.mobiTc = true
            },
            ppMobi() {
                this.mobiPp = true
            },
            closePp(){
                this.mobiPp = false
            },
            closeTc(){
                this.mobiTc = false
            },
        }
    }
</script>
<style lang="scss" scoped>

    .banner {
        height: 100vh;
        width: 100%;
        overflow: hidden;

        .banner-bg {
            position: absolute;
            top: 0;
            left: 0;
            height: 64vh;
            width: 100%;
        }

        .banner-img {
            position: absolute;
            top: 30%;
            left: 24%;
            width: 100%;
            z-index: 2;
        }

        .banner-title {
            position: absolute;
            top: 58%;
            left: 27.5%;
            width: 45%;
            z-index: 2;

            .title-t {
                font-size: 4.2em;
                margin-bottom: 15px;
                letter-spacing: -5px;
                margin-bottom: 70px;
                text-shadow: 0px 30px 25px rgba(0,0,0,.32);
            }

            .title-s {
                font-size: 22px;
            }
        } 
    }

    .liner {
        padding: 0;
        height: 12px;
        border-radius: 20px;
        opacity: .84;

        &.l {
        width: 84%;

        &.rt {
            margin-left: 16%
        }
        }
        &.m {
        height: 28px;
        width: 64%;

        &.rt {
            margin-left: 36%
        }
        }
        &.s {
        height: 8px;
        width: 44%;

        &.rt {
            margin-left: 56%
        }
        }
    }

    .bg-circle {
        position: absolute;
        top: 65px;
        left: -45px;
        height: 300px;
        width: 300px;
        border-radius: 50%;
        z-index: 1;
        opacity: .84;
    }

    .bg-circle-ls {
        position: absolute;
        top: -105px;
        left: -45px;
        height: 300px;
        width: 300px;
        border-radius: 50%;
        z-index: 1;
        opacity: .45;

        &.ol {
            border: 10px solid;

        &.amber-line {
            border-color: #FFC107
        }
        &.tertiary-line {
            border-color: #00BCD4
        }
        &.accent-line {
            border-color: #2196F3
        }
        &.black-line {
            border-color: #000000
        }
        }
    }

    .liner-container {
        position: absolute;
        bottom: 16px;
        left: -10px;
        width: 45%;
    }

    .bg-hollow {
        position: absolute;
        height: 134%;
        width: 28%;
        border: 10px solid;
        opacity: .34;
        border-radius: 0 0 220px 220px;
        z-index: 1;

        &.mlb {
            left: -40px;
            top: -18%;
            height: 30%;
            width: 46%;
            border-radius: 0 220px 220px 0;
        }

        &.diag-rt {
            height: 80%;
            top: 20%;
            right: -18%;
            transform: rotate(30deg);
            border-radius: 0 0 300px 300px;
        }

        &.amber-line {
            border-color: #FFC107
        }
        &.tertiary-line {
            border-color: #00BCD4
        }
        &.accent-line {
            border-color: #2196F3
        }
        &.black-line {
            border-color: #000000
        }
    }

    .bg-rect {
        position: absolute;
        height: 45%;
        width: 10%;
        border: 30px solid;
        top: 27.5%;
        left:45%;
        border-radius: 220px;

        &.amber-line {
        border-color: #FFC107
        }
        &.tertiary-line {
        border-color: #00BCD4
        }
        &.accent-line {
        border-color: #2196F3
        }
        &.black-line {
        border-color: #000000
        }

        .balls {
        position: absolute;
        height: 60%;
        width: 60px;
        top: 20%;
        right: -45px;

        .b {
            height: 60px;
            width: 60px;
            border-radius: 50%;
        }
        }
    }

    .tablet {
        .banner {
            height: 100vh;
            width: 100%;
            overflow: hidden;

            .banner-bg {
                position: absolute;
                top: 0;
                left: 0;
                height: 64vh;
                width: 100%;
            }

            .banner-title {
                position: absolute;
                top: 50%;
                left: 27.5%;
                width: 45%;
                z-index: 2;

                .title-t {
                    font-size: 3.2em;
                    margin-bottom: 15px;
                    letter-spacing: -5px;
                    margin-bottom: 70px;
                    text-shadow: 0px 30px 25px rgba(0,0,0,.32);
                }

                .title-s {
                    font-size: 18px;
                }
            } 
        }

        .liner {
            padding: 0;
            height: 8px;
            border-radius: 20px;

            &.l {
                width: 84%;

                &.rt {
                margin-left: 16%
                }
            }
            &.m {
                height: 24px;
                width: 64%;

                &.rt {
                margin-left: 36%
                }
            }
            &.s {
                height: 4px;
                width: 44%;

                &.rt {
                margin-left: 56%
                }
            }
        }

        .bg-circle {
            position: absolute;
            top: 65px;
            left: -45px;
            height: 200px;
            width: 200px;
            border-radius: 50%;
            z-index: 1;
            opacity: .84;
        }

        .bg-circle-ls {
            position: absolute;
            top: -105px;
            left: -45px;
            height: 300px;
            width: 300px;
            border-radius: 50%;
            z-index: 1;
            opacity: .45;

            &.ol {
                border: 10px solid;

                &.amber-line {
                    border-color: #FFC107
                }
                &.tertiary-line {
                    border-color: #00BCD4
                }
                &.accent-line {
                    border-color: #2196F3
                }
                &.black-line {
                    border-color: #000000
                }
            }
        }

        .bg-hollow {
            position: absolute;
            height: 134%;
            width: 28%;
            border: 10px solid;
            opacity: .34;
            border-radius: 0 0 220px 220px;
            z-index: 1;

            &.tl {
                left: 1.5%;
                top: -40px;
            }

            &.tr {
                right: 4.5%;
                top: -40px;
            }

            &.ml {
                left: -40px;
                top: 34%;
                height: 40%;
                width: 60%;
                border-radius: 0 120px 120px 0;
            }

            &.mlb {
                left: -40px;
                top: -18%;
                height: 30%;
                width: 46%;
                border-radius: 0 220px 220px 0;
            }

            &.diag-rt {
                height: 80%;
                top: 20%;
                right: -12%;
                transform: rotate(30deg);
                border-radius: 0 0 300px 300px;
            }

            &.amber-line {
                border-color: #FFC107
            }
            &.tertiary-line {
                border-color: #00BCD4
            }
            &.accent-line {
                border-color: #2196F3
            }
            &.black-line {
                border-color: #000000
            }
        }

        .bg-rect {
            position: absolute;
            height: 45%;
            width: 10%;
            border: 30px solid;
            top: 20%;
            left:45%;
            border-radius: 220px;

            &.amber-line {
                border-color: #FFC107
            }
            &.tertiary-line {
                border-color: #00BCD4
            }
            &.accent-line {
                border-color: #2196F3
            }
            &.black-line {
                border-color: #000000
            }

            .balls {
                position: absolute;
                height: 60%;
                width: 60px;
                top: 20%;
                right: -45px;

                .b {
                    height: 60px;
                    width: 60px;
                    border-radius: 50%;
                }
            }
        }
    }

    .mobi {
        .banner {
            height: 100vh;
            width: 100%;

            .banner-bg {
                position: absolute;
                top: 0;
                left: 0;
                height: 64vh;
                width: 100%;
            }

            .banner-img {
                position: absolute;
                top: 44%;
                left: 40%;
                width: 20%;
                z-index: 2;
            }

            .banner-title {
                position: absolute;
                top: 58%;
                left: 17.5%;
                width: 65%;
                z-index: 2;

                .title-t {
                    font-size: 40px;
                    margin-bottom: 15px;
                    line-height: 50px;
                    letter-spacing: -2.5px;
                    @media screen and (max-width: 320px) {
                        margin-bottom: 40px;
                    }
                    margin-bottom: 80px
                }

                .title-s {
                    font-size: 16px;
                    line-height: 30px;
                }
            }
        }

        .liner-container {
            position: absolute;
            bottom: 16px;
            left: -10px;
            width: 100%;
        }

        .liner {
            padding: 0;
            height: 4px;
            border-radius: 20px;
            opacity: .84;

            &.l {
            width: 84%;

                &.rt {
                    margin-left: 16%
                }
            }
            &.m {
                height: 14px;
                width: 64%;

                &.rt {
                    margin-left: 36%
                }
            }
            &.s {
                height: 8px;
                width: 44%;

                &.rt {
                    margin-left: 56%
                }
            }
        }

        .bg-circle {
            position: absolute;
            top: 15px;
            left: -45px;
            height: 120px;
            width: 120px;
            border-radius: 50%;
            z-index: 1;
            opacity: .84;
        }

        .bg-circle-ls {
            position: absolute;
            top: -105px;
            left: -75px;
            height: 200px;
            width: 200px;
            border-radius: 50%;
            z-index: 1;
            opacity: .45;

            &.ol {
                border: 10px solid;

            &.amber-line {
                border-color: #FFC107
            }
            &.tertiary-line {
                border-color: #00BCD4
            }
            &.accent-line {
                border-color: #2196F3
            }
            &.black-line {
                border-color: #000000
            }
            }
        }

        .bg-hollow {
            position: absolute;
            height: 134%;
            width: 28%;
            border: 10px solid;
            opacity: .34;
            border-radius: 0 0 220px 220px;
            z-index: 1;

            &.mlb {
                left: -40px;
                top: -10%;
                height: 20%;
                width: 96%;
                border-radius: 0 220px 220px 0;
            }

            &.amber-line {
                border-color: #FFC107
            }
            &.tertiary-line {
                border-color: #00BCD4
            }
            &.accent-line {
                border-color: #2196F3
            }
            &.black-line {
                border-color: #000000
            }
        }

        .bg-rect {
            position: absolute;
            height: 45%;
            width: 28%;
            border: 20px solid;
            top: 27.5%;
            left:36%;
            border-radius: 220px;

            &.amber-line {
                border-color: #FFC107
            }
            &.tertiary-line {
                border-color: #00BCD4
            }
            &.accent-line {
                border-color: #2196F3
            }
            &.black-line {
                border-color: #000000
            }
        } 
    }

    .cs-copyright {
        position: fixed;
        bottom: 10px;
        right: 0;
        width: 100%;
        z-index: 4
    }

    .hotspot {
        position: fixed;
        bottom: 0;
        right: 50px;;
        height: 40px;
        width: 100px;
        z-index: 4
    }
</style>